module.exports = __webpack_public_path__ + "media/accept_sound.32b69002.mp3";